var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTutorialsNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.25 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tutorials-notifications") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.42,21.45c-1.3-1.3-2.92-2.93-2.92-9.26a9.38,9.38,0,0,0-7.83-9.25,1.87,1.87,0,1,0-3.09,0,9.38,9.38,0,0,0-7.83,9.25c0,6.34-1.62,8-2.92,9.26a2.81,2.81,0,0,0,2,4.8H9.38a3.75,3.75,0,1,0,7.5,0h6.56A2.81,2.81,0,0,0,25.42,21.45Zm-12.3,6.21a.47.47,0,0,1,0,.94,2.35,2.35,0,0,1-2.34-2.34h.94A1.41,1.41,0,0,0,13.13,27.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorialsNotifications);
export default __webpack_public_path__ + "static/media/icon-tutorials-notifications.3834301fb55a77301438776ef198af81.svg";
export { ForwardRef as ReactComponent };